import SettingsContainer from 'trunks/vue/admin/components/settings/settings_container.js'

function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta ? meta.getAttribute('content') : ''
}

export default Vue.extend({
  components: {
    'settings-container': SettingsContainer
  },

  props: {
    snippetsData: {
      type: Object,
      required: true
    }
  },

  computed: {
    snippets() {
      return this.snippetsData.snippets || []
    },

    paths() {
      return this.snippetsData.paths || {}
    },

    authenticityToken() {
      return csrfToken()
    }
  },

  methods: {
    confirmDelete(snippet, event) {
      if (!window.confirm(`确定删除片段 ${snippet.name} ？`)) event.preventDefault()
    }
  },

  template: `
    <settings-container active-tab="templates">
      <template slot="content">
        <div class="templates-settings snippets-settings">
          <div class="templates-header">
            <div>
              <div class="templates-kicker">模板设置</div>
              <h1>所有片段</h1>
              <p>管理可在模板中通过 include 引用的代码片段。</p>
            </div>
            <div class="templates-header-actions">
              <a :href="paths.templates" class="btn btn-default btn-small outlined">返回模板设置</a>
              <a :href="paths.new" class="btn btn-primary btn-small">
                <i class="slp-plus"></i>
                添加片段
              </a>
            </div>
          </div>

          <div class="panel-card templates-card snippets-card">
            <div class="panel-card-head">
              <span class="panel-card-title">片段列表</span>
              <a :href="paths.new" class="btn icon-btn link-btn squared" title="添加片段">
                <i class="fa fa-plus"></i>
              </a>
            </div>
            <div class="panel-card-body">
              <div v-if="snippets.length === 0" class="templates-empty">请先添加片段</div>
              <div v-else class="snippets-list">
                <div v-for="snippet in snippets"
                     :key="snippet.id"
                     class="snippet-list-item">
                  <a :href="snippet.paths.show" class="snippet-list-copy">
                    <span class="template-name">{{ snippet.name }}</span>
                    <span class="template-meta">{{ snippet.slug }}</span>
                    <code>{{ snippet.include_code }}</code>
                  </a>
                  <div class="template-actions">
                    <a :href="snippet.paths.show" class="btn icon-btn link-btn squared" title="编辑">
                      <i class="fa fa-pencil"></i>
                    </a>
                    <form :action="snippet.paths.destroy"
                          method="post"
                          class="inline-template-form"
                          @submit="confirmDelete(snippet, $event)">
                      <input type="hidden" name="authenticity_token" :value="authenticityToken" />
                      <input type="hidden" name="_method" value="delete" />
                      <button type="submit" class="btn icon-btn link-btn squared" title="删除">
                        <i class="fa fa-trash"></i>
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </settings-container>
  `
})
